var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141806",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1546",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48377",
    d: "M54 27A27 27 0 1 1 27 0a27 27 0 0 1 27 27Zm-31.826-6.639h-4.455c-.1-6.365 4.826-8.549 9.3-8.549 4.715 0 9.021 2.464 9.021 7.56 0 3.645-2.144 5.38-4.2 6.942-2.487 1.887-3.408 2.592-3.408 5.016v1.2H24.02L24 30.966c-.128-3.129 1.671-5.055 3.942-6.707 1.99-1.5 3.257-2.484 3.257-4.628 0-2.784-2.12-3.942-4.436-3.942-3.041 0-4.584 2.036-4.584 4.671ZM26.4 42.106a3.16 3.16 0 1 1 0-6.3 3.166 3.166 0 1 1 0 6.3Z",
    fill: "#185edf",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.e4dddc2081913ddd8c3e1156f3b49cf1.svg";
export { ForwardRef as ReactComponent };